module.exports = __webpack_public_path__ + "img/Mensagem.766cc87b.jpg";